import styled from 'styled-components';

export const Wrapper = styled.div`
    & div[data-test="options"],
    & div[data-test="acc-includes"] {
        width: 100%;
        border: none;
        color: inherit;
        padding: 0;
        margin-top: 16px;
        background: none;
    }
`;
